import { ColumnLayout, FlexLayout, SquareLayout } from "@albelli/list-view-react"

class FilterStore {
  private layouts = {
    square: (size: number) => new SquareLayout(size, 5, 5),
    flex: (size: number) => new FlexLayout(size, 5, 5),
    "single-column": () => new ColumnLayout(1, 5),
    "two-columns": () => new ColumnLayout(2, 5)
  }

  private itemSize = 220
  private layoutId = "flex"

  private listener: any = null
  private updateCallback: any = null

  register(listener: any, updateCallback = () => this.listener.forceUpdate()) {
    this.listener = listener
    this.updateCallback = updateCallback
  }

  update() {
    this.updateCallback()
  }

  getItemSize() {
    return this.itemSize
  }

  setItemSize(itemSize: number) {
    this.itemSize = itemSize
    this.update()
  }

  getLayoutId() {
    return this.layoutId
  }

  setLayoutId(layoutId: string) {
    this.layoutId = layoutId
    this.update()
  }

  getLayouts(itemSize: number, layoutId = this.getLayoutId()) {
    return this.layouts[layoutId](itemSize)
  }
}

export default new FilterStore()
